import { useCallback } from 'react';

import { ScreenReaderOnly } from '@capsule/consumer-design-system';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { Typography } from 'src/app/components/Elements/Typography';
import { ShareButton } from 'src/app/components/Pages/ShowYourDoctor/Sections/ShareButton';
import { segmentTrack } from 'src/app/state/actions';
import { useDispatch } from 'src/app/state/store';
import type { Facility, ScrolledToSegmentPayload } from 'src/app/types';

import {
  DoctorCardAddress,
  DoctorCardButtonSection,
  DoctorCardContainer,
  DoctorCardFaxNumberContainer,
  DoctorCardLeftSection,
  DoctorCardPhoneNumberContainer,
  DoctorCardRightSection,
  DoctorCardTitle,
  InlineSVGDoctorCardPills,
  ShowDoctorCard,
} from './styles';

interface DoctorCardProps {
  facility: Facility;
  pagePath: ScrolledToSegmentPayload;
}
export const DoctorCard = ({ facility, pagePath }: DoctorCardProps) => {
  const dispatch = useDispatch();
  const dispatchSegmentTrack = useCallback(
    (event: UnifiedEvent, payload) => dispatch(segmentTrack(event, payload) as any),
    [dispatch]
  );

  const { address: facilityAddress, phone, fax } = facility;
  const { address, city, state, zipCode } = facilityAddress ?? {};

  return (
    <ShowDoctorCard>
      <DoctorCardContainer>
        <InlineSVGDoctorCardPills />

        <DoctorCardContainer>
          <DoctorCardLeftSection>
            <DoctorCardTitle>
              <Typography variant={'small'} color={'capsuleGreen55'}>
                Prescribe to:
              </Typography>
              <Typography variant={'h1'} color={'white'}>
                Capsule&nbsp;-
              </Typography>
              <Typography variant={'h1'} color={'white'}>
                {city}
              </Typography>
            </DoctorCardTitle>
            <DoctorCardAddress>
              <Typography variant={'small'} color={'white'}>
                {address}. {city}, {state} {zipCode}
              </Typography>
              <DoctorCardPhoneNumberContainer>
                {phone && (
                  <Typography variant={'small'} color={'capsuleGreen55'}>
                    <span aria-hidden="true">P:&nbsp;</span>
                    <ScreenReaderOnly>Phone:</ScreenReaderOnly>
                  </Typography>
                )}
                <Typography variant={'small'} color={'white'}>
                  {phone}
                </Typography>
              </DoctorCardPhoneNumberContainer>
              <DoctorCardFaxNumberContainer>
                {fax && (
                  <Typography variant={'small'} color={'capsuleGreen55'}>
                    <span aria-hidden="true">F:&nbsp;</span>
                    <ScreenReaderOnly>Fax:</ScreenReaderOnly>
                  </Typography>
                )}
                <Typography variant={'small'} color={'white'}>
                  {fax}
                </Typography>
              </DoctorCardFaxNumberContainer>
            </DoctorCardAddress>
          </DoctorCardLeftSection>
        </DoctorCardContainer>
        <DoctorCardRightSection>
          <DoctorCardButtonSection>
            <ShareButton
              facility={facility}
              segmentTrack={dispatchSegmentTrack}
              pagepath={pagePath}
              style="newSecondary"
              size="small"
            />
          </DoctorCardButtonSection>
        </DoctorCardRightSection>
      </DoctorCardContainer>
    </ShowDoctorCard>
  );
};
